import React from 'react';
import { Button, BUTTON_THEMES, Modal } from 'ht-styleguide';
/* Components */
import ThankYouContent from '@components/Modals/FirstServiceDiscount/FirstServiceDiscountThankYou/firstServiceDiscountThankYou.content';
/* Types */
import { Dispatcher } from 'types/base.types';
import styles from '../firstservicediscount.module.scss';

/* Types */
type FirstServiceDiscountThankYouProps = {
  code: string;
  visible: boolean;
  close: Dispatcher<boolean>;
};

const ConfirmButton = ({ close }: Partial<FirstServiceDiscountThankYouProps>) => (
  <Button small className={styles.firstServiceDiscountModalClose} theme={BUTTON_THEMES.PRIMARY} onClick={close}>
    Got it
  </Button>
);

const FirstServiceDiscountThankYou = ({ close, code, visible = false }: FirstServiceDiscountThankYouProps) => (
  <Modal isVisible={visible} footerElement3={<ConfirmButton close={close} />} hide={close} onRequestClose={close}>
    <ThankYouContent code={code} close={close} />
  </Modal>
);

export default React.memo(FirstServiceDiscountThankYou);
